/** Option fields a new scale question starts with; they cannot be removed. */
export const MIN_VISIBLE_OPTIONS = 5

/** Most options a survey scale accepts; the API rejects more. */
export const MAX_OPTIONS = 10
